import { AR, BO, BR, CL, CO, MX, PE } from 'country-flag-icons/string/1x1'

import i18n from '../utils/i18n.utils'
import { BalanceTransactionType, PaymentStatus } from './enums.lib'
import ReviewedRegistryIcon from '../assets/icons/reviewed-registry-icon.svg'
import RejectedRegistryIcon from '../assets/icons/rejected-registry-icon.svg'
import WarningUserRegistryIcon from '../assets/icons/warning-user-registry-icon.svg'
import EmptyBankDataRegistryIcon from '../assets/icons/empty-bank-data-registry-icon.svg'
import WrongUserDataRegistryIcon from '../assets/icons/wrong-user-data-registry-icon.svg'
import WarningBankDataRegistryIcon from '../assets/icons/warning-bank-data-registry-icon.svg'
import BackgroundResearchRegistryIcon from '../assets/icons/background-research-registry-icon.svg'
import EmptyPaymentAmountRegistryIcon from '../assets/icons/empty-payment-amount-registry-icon.svg'
import WrongPaymentAmountRegistryIcon from '../assets/icons/wrong-payment-amount-registry-icon.svg'
import EmptyRegisteredNameRegistryIcon from '../assets/icons/empty-registered-name-registry-icon.svg'
import WrongDocumentNumberRegistryIcon from '../assets/icons/wrong-document-number-registry-icon.svg'
import EmptyPaymentReferenceRegistryIcon from '../assets/icons/empty-payment-reference-registry-icon.svg'
import WrongBankAccountNumberRegistryIcon from '../assets/icons/wrong-bank-account-number-registry-icon.svg'
import EmptyBankAccountNumberRegistryIcon from '../assets/icons/empty-bank-account-number-registry-icon.svg'
import WarningBankAccountNumberRegistryIcon from '../assets/icons/warning-bank-account-number-registry-icon.svg'
import DuplicatePaymentReferenceRegistryIcon from '../assets/icons/duplicate-payment-reference-registry-icon.svg'
import NotRegisteredBankAccountNumberRegistryIcon from '../assets/icons/not-registered-bank-account-number-registry-icon.svg'

import CobreLogo from '../assets/images/logo-cobre.svg'
import MonnetLogo from '../assets/images/logo-monnet.svg'
import KoyweLogo from '../assets/images/logo-koywe.svg'
import FacilitaLogo from '../assets/images/logo-facilita.svg'
import PassportLogo from '../assets/images/logo-passport.svg'
import PlentiLogo from '../assets/images/logo-plenti.svg'

export const getNoveltyIconByType = {
  rejected: RejectedRegistryIcon,
  reviewed: ReviewedRegistryIcon,
  'empty-bank-code': EmptyBankDataRegistryIcon,
  'empty-bank-name': EmptyBankDataRegistryIcon,
  'unknown-bank-code': WarningBankDataRegistryIcon,
  'unknown-bank-name': WarningBankDataRegistryIcon,
  'wrong-document-type': WrongUserDataRegistryIcon,
  'empty-document-number': WarningUserRegistryIcon,
  'background-research': BackgroundResearchRegistryIcon,
  'empty-payment-amount': EmptyPaymentAmountRegistryIcon,
  'wrong-payment-amount': WrongPaymentAmountRegistryIcon,
  'waiting-for-resolution': BackgroundResearchRegistryIcon,
  'empty-registered-name': EmptyRegisteredNameRegistryIcon,
  'wrong-document-number': WrongDocumentNumberRegistryIcon,
  'empty-payment-reference': EmptyPaymentReferenceRegistryIcon,
  'empty-bank-account-type': EmptyBankAccountNumberRegistryIcon,
  'wrong-bank-account-type': WrongBankAccountNumberRegistryIcon,
  'wrong-bank-account-number': WrongBankAccountNumberRegistryIcon,
  'empty-bank-account-number': WarningBankAccountNumberRegistryIcon,
  'duplicate-bank-account-number': EmptyBankAccountNumberRegistryIcon,
  'duplicate-payment-reference': DuplicatePaymentReferenceRegistryIcon,
  'bank-account-number-not-registered': NotRegisteredBankAccountNumberRegistryIcon
}

export const getNoveltyShortDescriptionByType = {
  'empty-bank-code': i18n.t('common:paymentNoveltiesShortDescription.emptyBankCode'),
  'empty-bank-name': i18n.t('common:paymentNoveltiesShortDescription.emptyBankName'),
  'unknown-bank-code': i18n.t('common:paymentNoveltiesShortDescription.unknownBankCode'),
  'unknown-bank-name': i18n.t('common:paymentNoveltiesShortDescription.unknownBankName'),
  'wrong-document-type': i18n.t('common:paymentNoveltiesShortDescription.wrongDocumentType'),
  'background-research': i18n.t('common:paymentNoveltiesShortDescription.backgroundResearch'),
  'empty-payment-amount': i18n.t('common:paymentNoveltiesShortDescription.emptyPaymentAmount'),
  'wrong-payment-amount': i18n.t('common:paymentNoveltiesShortDescription.wrongPaymentAmount'),
  'empty-registered-name': i18n.t('common:paymentNoveltiesShortDescription.emptyRegisteredName'),
  'wrong-document-number': i18n.t('common:paymentNoveltiesShortDescription.wrongDocumentNumber'),
  'empty-document-number': i18n.t('common:paymentNoveltiesShortDescription.emptyDocumentNumber'),
  'waiting-for-resolution': i18n.t('common:paymentNoveltiesShortDescription.waitingForResolution'),
  'wrong-bank-account-type': i18n.t('common:paymentNoveltiesShortDescription.wrongBankAccountType'),
  'empty-bank-account-type': i18n.t('common:paymentNoveltiesShortDescription.emptyBankAccountType'),
  'empty-payment-reference': i18n.t('common:paymentNoveltiesShortDescription.emptyPaymentReference'),
  'wrong-bank-account-number': i18n.t('common:paymentNoveltiesShortDescription.wrongBankAccountNumber'),
  'empty-bank-account-number': i18n.t('common:paymentNoveltiesShortDescription.emptyBankAccountNumber'),
  'duplicate-payment-reference': i18n.t('common:paymentNoveltiesShortDescription.duplicatePaymentReference'),
  'duplicate-bank-account-number': i18n.t('common:paymentNoveltiesShortDescription.duplicateBankAccountNumber'),
  'bank-account-number-not-registered': i18n.t('common:paymentNoveltiesShortDescription.bankAccountNumberNotRegistered')
}

export const syncSessions = ['/system-users', '/documents-to-review', '/beneficiaries', '/documents-ready', '/documents-completed']

export const messageByNotificationType = {
  'close-session': {
    type: 'string',
    message: i18n.t('common:toastMessages.closeSession')
  },
  'password-recovered': {
    type: 'string',
    message: i18n.t('common:toastMessages.passwordRecovered')
  },
  'payment-status-updated-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentStatusUpdatedSuccess')
  },
  'batch-sent-to-disperse-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.batchSentToDisperseSuccess')
  },
  'password-updated': {
    type: 'string',
    message: i18n.t('common:toastMessages.passwordUpdated')
  },
  'profile-updated': {
    type: 'string',
    message: i18n.t('common:toastMessages.profileUpdated')
  },
  'system-users-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.systemUsersDeleted')
  },
  'system-users-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.systemUsersCreated')
  },
  'customer-company-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerCompanyCreated')
  },
  'customer-company-funding-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerCompanyFundingCreated')
  },
  'customer-company-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerCompanyDeleted')
  },
  'system-users-updated': {
    type: 'string',
    message: i18n.t('common:toastMessages.systemUsersUpdated')
  },
  'document-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentDeleted')
  },
  'document-stopped': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentStopped')
  },
  'document-resumed': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentResumed')
  },
  'document-ready-for-disperse': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentReadyForDisperse')
  },
  'document-error': {
    type: 'link',
    message: i18n.t('common:toastMessages.documentError')
  },
  'document-completed': {
    type: 'link',
    message: i18n.t('common:toastMessages.documentCompleted')
  },
  'customer-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerCreated')
  },
  'customer-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerDeleted')
  },
  'payment-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentDeleted')
  },
  'deletion-process-interrupted': {
    type: 'string',
    message: i18n.t('common:toastMessages.deletionProcessInterrupted')
  },
  'bank-account-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.bankAccountCreated')
  },
  'customer-company-updated': {
    type: 'string',
    message: i18n.t('common:toastMessages.customerCompanyUpdated')
  },
  'bank-account-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.bankAccountDeleted')
  },
  'bank-account-setted-as-main': {
    type: 'string',
    message: i18n.t('common:toastMessages.bankAccountSettedAsMain')
  },
  'document-finding-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentFindingDeleted')
  },
  'document-finding-approved': {
    type: 'string',
    message: i18n.t('common:toastMessages.documentFindingApproved')
  },
  'resend-email-notification-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.resendEmailNotificationSuccess')
  },
  'client-balance-updated-successfully': {
    type: 'string',
    message: i18n.t('common:toastMessages.clientBalanceUpdatedSuccessfully')
  },
  'bank-balance-updated-successfully': {
    type: 'string',
    message: i18n.t('common:toastMessages.bankBalanceUpdatedSuccessfully')
  },
  'resend-email-notification-error': {
    type: 'string',
    message: i18n.t('common:toastMessages.resendEmailNotificationError')
  },
  'payment-rejected-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentRejectedSuccess')
  },
  'payment-deleted-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentDeletedSuccess')
  },
  'requested-report-deleted-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.requestedReportDeletedSuccess')
  },
  'payment-sent-successfully': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentSentSuccess')
  },
  'payment-sent-with-novelties': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentSentWithNoveltiesSuccess')
  },
  'payment-novelty-approved-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentNoveltyApprovedSuccess')
  },
  'someone-else-resolve-allocation': {
    type: 'string',
    message: i18n.t('common:toastMessages.someoneElseResolveAllocation')
  },
  'reject-funding-allocation-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.rejectFundingAllocationSuccess')
  },
  'revert-funding-allocation-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.revertFundingAllocationSuccess')
  },
  'approve-funding-allocation-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.approveFundingAllocationSuccess')
  },
  'payments-history-report-created-success': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentsHistoryCreated')
  },
  'pocket-created': {
    type: 'string',
    message: i18n.t('common:toastMessages.pocketCreated')
  },
  'pocket-name-updated': {
    type: 'string',
    message: i18n.t('common:toastMessages.pocketNameUpdated')
  },
  'pocket-transfer': {
    type: 'string',
    message: i18n.t('common:toastMessages.pocketTransfer')
  },
  'pocket-deleted': {
    type: 'string',
    message: i18n.t('common:toastMessages.pocketDeleted')
  },
  'payment-request-added': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentRequestAdded')
  },
  'payment-compliance-comment-added': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentComplianceCommentAdded')
  },
  'payment-response-added': {
    type: 'string',
    message: i18n.t('common:toastMessages.paymentResponseAdded')
  },
  'crypto-payment-sent': {
    type: 'string',
    message: i18n.t('common:toastMessages.cryptoPaymentSentSuccessfully')
  }
}

export const customersDocumentType = {
  N: 'NIT',
  /*P: i18n.t('documentTypes.passport', { ns: 'common' }),*/
  PA: i18n.t('documentTypes.passport', { ns: 'common' }),
  C: i18n.t('documentTypes.nationalId', { ns: 'common' }),
  E: i18n.t('documentTypes.foreignId', { ns: 'common' }),
  /*CE: 'Cédula de extranjería',*/
  PEP: 'PEP/PPT'
}

export const mexicanCustomersDocumentType = {
  rfc: 'RFC',
  curp: 'CURP'
}

export const brazilianCustomersDocumentType = {
  cpf: 'CPF',
  curp: 'CURP',
  passport: 'PASSPORT'
}

export const chileanCustomersDocumentType = {
  rut: 'RUT'
}

export const peruvianCustomersDocumentType = {
  dni: 'DNI',
  ruc: 'Registro Único de Contribuyentes',
  ced_ext: 'Carné de Extranjería'
}

export const argentinianCustomersDocumentType = {
  dni: 'DNI',
  cuit: 'CUIT'
}

export const customersBankAccountType = {
  '1': i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  '2': i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' }),
  breb: 'BRE-B',
  /* '27': i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  '37': i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' }), */
  '3': i18n.t('customersBankAccountType.notRegistered', { ns: 'common' })
}

export const mexicanBankAccountType = {
  clabe: 'CLABE',
  spei_card: 'SPEI'
}

export const brazilianBankAccountType = {
  checking: i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  savings: i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' }),
  pix: 'PIX'
}

export const argentinianBankAccountType = {
  checking: i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  savings: i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' })
}

export const chileanBankAccountType = {
  checking: i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  savings: i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' })
}

export const peruvianBankAccountType = {
  checking: i18n.t('customersBankAccountType.checkingAccount', { ns: 'common' }),
  savings: i18n.t('customersBankAccountType.savingsAccount', { ns: 'common' })
}

export const corporationIndustries = {
  Accounting: i18n.t('corporationIndustries.accounting', { ns: 'common' }),
  'Airlines/Aviation': i18n.t('corporationIndustries.airlinesAviation', { ns: 'common' }),
  'Alternative Dispute Resolution': i18n.t('corporationIndustries.alternativeDisputeResolution', { ns: 'common' }),
  'Alternative Medicine': i18n.t('corporationIndustries.alternativeMedicine', { ns: 'common' }),
  Animation: i18n.t('corporationIndustries.animation', { ns: 'common' }),
  'Apparel & Fashion': i18n.t('corporationIndustries.apparelFashion', { ns: 'common' }),
  'Architecture & Planning': i18n.t('corporationIndustries.architecturePlanning', { ns: 'common' }),
  'Arts & Crafts': i18n.t('corporationIndustries.artsCrafts', { ns: 'common' }),
  Automotive: i18n.t('corporationIndustries.automotive', { ns: 'common' }),
  'Aviation & Aerospace': i18n.t('corporationIndustries.aviationAerospace', { ns: 'common' }),
  Banking: i18n.t('corporationIndustries.banking', { ns: 'common' }),
  Biotechnology: i18n.t('corporationIndustries.biotechnology', { ns: 'common' }),
  'Broadcast Media': i18n.t('corporationIndustries.broadcastMedia', { ns: 'common' }),
  'Building Materials': i18n.t('corporationIndustries.buildingMaterials', { ns: 'common' }),
  'Business Supplies & Equipment': i18n.t('corporationIndustries.businessSuppliesEquipment', { ns: 'common' }),
  'Capital Markets': i18n.t('corporationIndustries.capitalMarkets', { ns: 'common' }),
  Chemicals: i18n.t('corporationIndustries.chemicals', { ns: 'common' }),
  'Civic & Social Organization': i18n.t('corporationIndustries.civicSocialOrganization', { ns: 'common' }),
  'Civil Engineering': i18n.t('corporationIndustries.civilEngineering', { ns: 'common' }),
  'Commercial Real Estate': i18n.t('corporationIndustries.commercialRealEstate', { ns: 'common' }),
  'Computer & Network Security': i18n.t('corporationIndustries.computerNetworkSecurity', { ns: 'common' }),
  'Computer Games': i18n.t('corporationIndustries.computerGames', { ns: 'common' }),
  'Computer Hardware': i18n.t('corporationIndustries.computerHardware', { ns: 'common' }),
  'Computer Networking': i18n.t('corporationIndustries.computerNetworking', { ns: 'common' }),
  'Computer Software': i18n.t('corporationIndustries.computerSoftware', { ns: 'common' }),
  Construction: i18n.t('corporationIndustries.construction', { ns: 'common' }),
  'Consumer Electronics': i18n.t('corporationIndustries.consumerElectronics', { ns: 'common' }),
  'Consumer Goods': i18n.t('corporationIndustries.consumerGoods', { ns: 'common' }),
  'Consumer Services': i18n.t('corporationIndustries.consumerServices', { ns: 'common' }),
  Cosmetics: i18n.t('corporationIndustries.cosmetics', { ns: 'common' }),
  Dairy: i18n.t('corporationIndustries.dairy', { ns: 'common' }),
  'Defense & Space': i18n.t('corporationIndustries.defenseSpace', { ns: 'common' }),
  Design: i18n.t('corporationIndustries.design', { ns: 'common' }),
  'Education Management': i18n.t('corporationIndustries.educationManagement', { ns: 'common' }),
  'E-learning': i18n.t('corporationIndustries.elearning', { ns: 'common' }),
  'Electrical & Electronic Manufacturing': i18n.t('corporationIndustries.electricalElectronicManufacturing', { ns: 'common' }),
  Entertainment: i18n.t('corporationIndustries.entertainment', { ns: 'common' }),
  'Environmental Services': i18n.t('corporationIndustries.environmentalServices', { ns: 'common' }),
  'Events Services': i18n.t('corporationIndustries.eventsServices', { ns: 'common' }),
  'Executive Office': i18n.t('corporationIndustries.executiveOffice', { ns: 'common' }),
  'Facilities Services': i18n.t('corporationIndustries.facilitiesServices', { ns: 'common' }),
  Farming: i18n.t('corporationIndustries.farming', { ns: 'common' }),
  'Financial Services': i18n.t('corporationIndustries.financialServices', { ns: 'common' }),
  'Fine Art': i18n.t('corporationIndustries.fineArt', { ns: 'common' }),
  Fishery: i18n.t('corporationIndustries.fishery', { ns: 'common' }),
  'Food & Beverages': i18n.t('corporationIndustries.foodBeverages', { ns: 'common' }),
  'Food Production': i18n.t('corporationIndustries.foodProduction', { ns: 'common' }),
  Fundraising: i18n.t('corporationIndustries.fundraising', { ns: 'common' }),
  Furniture: i18n.t('corporationIndustries.furniture', { ns: 'common' }),
  'Gambling & Casinos': i18n.t('corporationIndustries.gamblingCasinos', { ns: 'common' }),
  'Glass, Ceramics & Concrete': i18n.t('corporationIndustries.glassCeramicsConcrete', { ns: 'common' }),
  'Government Administration': i18n.t('corporationIndustries.governmentAdministration', { ns: 'common' }),
  'Government Relations': i18n.t('corporationIndustries.governmentRelations', { ns: 'common' }),
  'Graphic Design': i18n.t('corporationIndustries.graphicDesign', { ns: 'common' }),
  'Health, Wellness & Fitness': i18n.t('corporationIndustries.healthWellnessFitness', { ns: 'common' }),
  'Higher Education': i18n.t('corporationIndustries.higherEducation', { ns: 'common' }),
  'Hospital & Health Care': i18n.t('corporationIndustries.hospitalHealthCare', { ns: 'common' }),
  Hospitality: i18n.t('corporationIndustries.hospitality', { ns: 'common' }),
  'Human Resources': i18n.t('corporationIndustries.humanResources', { ns: 'common' }),
  'Import & Export': i18n.t('corporationIndustries.importExport', { ns: 'common' }),
  'Individual & Family Services': i18n.t('corporationIndustries.individualFamilyServices', { ns: 'common' }),
  'Industrial Automation': i18n.t('corporationIndustries.industrialAutomation', { ns: 'common' }),
  'Information Services': i18n.t('corporationIndustries.informationServices', { ns: 'common' }),
  'Information Technology & Services': i18n.t('corporationIndustries.informationTechnologyServices', { ns: 'common' }),
  Insurance: i18n.t('corporationIndustries.insurance', { ns: 'common' }),
  'International Affairs': i18n.t('corporationIndustries.internationalAffairs', { ns: 'common' }),
  'International Trade & Development': i18n.t('corporationIndustries.internationalTradeDevelopment', { ns: 'common' }),
  Internet: i18n.t('corporationIndustries.internet', { ns: 'common' }),
  'Investment Banking/Venture': i18n.t('corporationIndustries.investmentBankingVenture', { ns: 'common' }),
  'Investment Management': i18n.t('corporationIndustries.investmentManagement', { ns: 'common' }),
  Judiciary: i18n.t('corporationIndustries.judiciary', { ns: 'common' }),
  'Law Enforcement': i18n.t('corporationIndustries.lawEnforcement', { ns: 'common' }),
  'Law Practice': i18n.t('corporationIndustries.lawPractice', { ns: 'common' }),
  'Legal Services': i18n.t('corporationIndustries.legalServices', { ns: 'common' }),
  'Legislative Office': i18n.t('corporationIndustries.legislativeOffice', { ns: 'common' }),
  'Leisure & Travel': i18n.t('corporationIndustries.leisureTravel', { ns: 'common' }),
  Libraries: i18n.t('corporationIndustries.libraries', { ns: 'common' }),
  'Logistics & Supply Chain': i18n.t('corporationIndustries.logisticsSupplyChain', { ns: 'common' }),
  'Luxury Goods & Jewelry': i18n.t('corporationIndustries.luxuryGoodsJewelry', { ns: 'common' }),
  Machinery: i18n.t('corporationIndustries.machinery', { ns: 'common' }),
  'Management Consulting': i18n.t('corporationIndustries.managementConsulting', { ns: 'common' }),
  Maritime: i18n.t('corporationIndustries.maritime', { ns: 'common' }),
  'Marketing & Advertising': i18n.t('corporationIndustries.marketingAdvertising', { ns: 'common' }),
  'Market Research': i18n.t('corporationIndustries.marketResearch', { ns: 'common' }),
  'Mechanical or Industrial Engineering': i18n.t('corporationIndustries.mechanicalOrIndustrialEngineering', { ns: 'common' }),
  'Media Production': i18n.t('corporationIndustries.mediaProduction', { ns: 'common' }),
  'Medical Device': i18n.t('corporationIndustries.medicalDevice', { ns: 'common' }),
  'Medical Practice': i18n.t('corporationIndustries.medicalPractice', { ns: 'common' }),
  'Mental Health Care': i18n.t('corporationIndustries.mentalHealthCare', { ns: 'common' }),
  Military: i18n.t('corporationIndustries.military', { ns: 'common' }),
  'Mining & Metals': i18n.t('corporationIndustries.miningMetals', { ns: 'common' }),
  'Motion Pictures & Film': i18n.t('corporationIndustries.motionPicturesFilm', { ns: 'common' }),
  'Museums & Institutions': i18n.t('corporationIndustries.museumsInstitutions', { ns: 'common' }),
  Music: i18n.t('corporationIndustries.music', { ns: 'common' }),
  Nanotechnology: i18n.t('corporationIndustries.nanotechnology', { ns: 'common' }),
  Newspapers: i18n.t('corporationIndustries.newspapers', { ns: 'common' }),
  'Nonprofit Organization Management': i18n.t('corporationIndustries.nonprofitOrganizationManagement', { ns: 'common' }),
  'Oil & Energy': i18n.t('corporationIndustries.oilEnergy', { ns: 'common' }),
  'Online Publishing': i18n.t('corporationIndustries.onlinePublishing', { ns: 'common' }),
  'Outsourcing/Offshoring': i18n.t('corporationIndustries.outsourcingOffshoring', { ns: 'common' }),
  'Package/Freight Delivery': i18n.t('corporationIndustries.packageFreightDelivery', { ns: 'common' }),
  'Packaging & Containers': i18n.t('corporationIndustries.packagingContainers', { ns: 'common' }),
  'Paper & Forest Products': i18n.t('corporationIndustries.paperForestProducts', { ns: 'common' }),
  'Performing Arts': i18n.t('corporationIndustries.performingArts', { ns: 'common' }),
  Pharmaceuticals: i18n.t('corporationIndustries.pharmaceuticals', { ns: 'common' }),
  Philanthropy: i18n.t('corporationIndustries.philanthropy', { ns: 'common' }),
  Photography: i18n.t('corporationIndustries.photography', { ns: 'common' }),
  Plastics: i18n.t('corporationIndustries.plastics', { ns: 'common' }),
  'Political Organization': i18n.t('corporationIndustries.politicalOrganization', { ns: 'common' }),
  'Primary/Secondary': i18n.t('corporationIndustries.primarySecondary', { ns: 'common' }),
  Printing: i18n.t('corporationIndustries.printing', { ns: 'common' }),
  'Professional Training': i18n.t('corporationIndustries.professionalTraining', { ns: 'common' }),
  'Program Development': i18n.t('corporationIndustries.programDevelopment', { ns: 'common' }),
  'Public Policy': i18n.t('corporationIndustries.publicPolicy', { ns: 'common' }),
  'Public Relations': i18n.t('corporationIndustries.publicRelations', { ns: 'common' }),
  'Public Safety': i18n.t('corporationIndustries.publicSafety', { ns: 'common' }),
  Publishing: i18n.t('corporationIndustries.publishing', { ns: 'common' }),
  'Railroad Manufacture': i18n.t('corporationIndustries.railroadManufacture', { ns: 'common' }),
  Ranching: i18n.t('corporationIndustries.ranching', { ns: 'common' }),
  'Real Estate': i18n.t('corporationIndustries.realEstate', { ns: 'common' }),
  'Recreational Facilities & Services': i18n.t('corporationIndustries.recreationalFacilitiesServices', { ns: 'common' }),
  'Religious Institutions': i18n.t('corporationIndustries.religiousInstitutions', { ns: 'common' }),
  'Renewables & Environment': i18n.t('corporationIndustries.renewablesEnvironment', { ns: 'common' }),
  Research: i18n.t('corporationIndustries.research', { ns: 'common' }),
  Restaurants: i18n.t('corporationIndustries.restaurants', { ns: 'common' }),
  Retail: i18n.t('corporationIndustries.retail', { ns: 'common' }),
  'Security & Investigations': i18n.t('corporationIndustries.securityInvestigations', { ns: 'common' }),
  Semiconductors: i18n.t('corporationIndustries.semiconductors', { ns: 'common' }),
  Shipbuilding: i18n.t('corporationIndustries.shipbuilding', { ns: 'common' }),
  'Sporting Goods': i18n.t('corporationIndustries.sportingGoods', { ns: 'common' }),
  Sports: i18n.t('corporationIndustries.sports', { ns: 'common' }),
  'Staffing & Recruiting': i18n.t('corporationIndustries.staffingRecruiting', { ns: 'common' }),
  Supermarkets: i18n.t('corporationIndustries.supermarkets', { ns: 'common' }),
  Telecommunications: i18n.t('corporationIndustries.telecommunications', { ns: 'common' }),
  Textiles: i18n.t('corporationIndustries.textiles', { ns: 'common' }),
  'Think Tanks': i18n.t('corporationIndustries.thinkTanks', { ns: 'common' }),
  Tobacco: i18n.t('corporationIndustries.tobacco', { ns: 'common' }),
  'Translation & Localization': i18n.t('corporationIndustries.translationLocalization', { ns: 'common' }),
  'Transportation/Trucking/Railroad': i18n.t('corporationIndustries.transportationTruckingRailroad', { ns: 'common' }),
  Utilities: i18n.t('corporationIndustries.utilities', { ns: 'common' }),
  'Venture Capital': i18n.t('corporationIndustries.ventureCapital', { ns: 'common' }),
  Veterinary: i18n.t('corporationIndustries.veterinary', { ns: 'common' }),
  Warehousing: i18n.t('corporationIndustries.warehousing', { ns: 'common' }),
  Wholesale: i18n.t('corporationIndustries.wholesale', { ns: 'common' }),
  'Wine & Spirits': i18n.t('corporationIndustries.wineSpirits', { ns: 'common' }),
  Wireless: i18n.t('corporationIndustries.wireless', { ns: 'common' }),
  'Writing & Editing': i18n.t('corporationIndustries.writingEditing', { ns: 'common' })
}

export const bankingPartnersData = [
  {
    bdValue: 'tpaga',
    value: 'tpaga',
    name: 'Tpaga'
  },
  {
    bdValue: 'banco-bbva',
    value: 'banco-bbva',
    name: 'Banco BBVA'
  },
  {
    bdValue: 'cobre-pexto',
    value: 'cobre-pexto',
    name: 'Cobre - Pexto'
  },
  {
    bdValue: 'banco-avvillas',
    value: 'banco-avvillas',
    name: 'Banco AVVillas'
  }
]

export const batchNoveltiesData = [
  {
    bdValue: 'with-novelties',
    name: i18n.t('reports-management:filters.batches.novelties.withNovelties')
  },
  {
    bdValue: 'without-novelties',
    name: i18n.t('reports-management:filters.batches.novelties.withoutNovelties')
  }
]

export const systemUserStatusesData = [
  {
    value: 'active',
    name: i18n.t('systemUserStatuses.active', { ns: 'common' })
  },
  {
    value: 'inactive',
    name: i18n.t('systemUserStatuses.inactive', { ns: 'common' })
  }
]

export const systemUserRolesData = [
  {
    value: 'admin',
    name: i18n.t('systemUserRoles.admin', { ns: 'common' })
  },
  {
    value: 'builder',
    name: i18n.t('systemUserRoles.builder', { ns: 'common' })
  }
]

export const customersDocumentTypeData = [
  {
    value: 'C',
    name: i18n.t('documentTypes.nationalId', { ns: 'common' })
  },
  {
    value: 'E',
    name: i18n.t('documentTypes.foreignId', { ns: 'common' })
  },
  {
    value: 'N',
    name: 'NIT'
  },
  {
    value: 'PA',
    name: i18n.t('documentTypes.passport', { ns: 'common' })
  },
  {
    value: 'PEP',
    name: 'PEP/PPT'
  }
]

export const batchStatusesData = [
  {
    bdValue: 'analyzing',
    name: i18n.t('reports-management:filters.batches.statuses.analyzing')
  },
  {
    bdValue: 'analysis-completed',
    name: i18n.t('reports-management:filters.batches.statuses.analysisCompleted')
  },
  {
    bdValue: 'completed',
    name: i18n.t('reports-management:filters.batches.statuses.completed')
  },
  {
    bdValue: 'dispersing',
    name: i18n.t('reports-management:filters.batches.statuses.dispersing')
  },
  {
    bdValue: 'error',
    name: i18n.t('reports-management:filters.batches.statuses.error')
  }
]

export const transactionTypesData = [
  {
    value: BalanceTransactionType.CREDITING_FUNDS,
    name: i18n.t('reports-management:modals.paymentsHistory.options.transactionTypes.funding')
  },
  {
    value: BalanceTransactionType.DEBIT,
    name: i18n.t('reports-management:modals.paymentsHistory.options.transactionTypes.debit')
  },
  {
    value: BalanceTransactionType.CREDIT,
    name: i18n.t('reports-management:modals.paymentsHistory.options.transactionTypes.credit')
  }
]

export const transactionStatusesData = [
  {
    value: PaymentStatus.VALIDATED,
    name: i18n.t('reports-management:modals.paymentsHistory.options.statuses.validated')
  },
  {
    value: PaymentStatus.PAID,
    name: i18n.t('reports-management:modals.paymentsHistory.options.statuses.paid')
  },
  {
    value: PaymentStatus.RETURNED,
    name: i18n.t('reports-management:modals.paymentsHistory.options.statuses.returned')
  }
]

export const countriesCurrencies = {
  COL: 'COP',
  MEX: 'MXN',
  ARG: 'ARS',
  BRA: 'BRL',
  BOL: 'BOB',
  CHI: 'CLP',
  PER: 'PEN'
}

export const flagCodes = {
  COL: CO,
  MEX: MX,
  ARG: AR,
  BRA: BR,
  BOL: BO,
  CHI: CL,
  PER: PE
}

export const countriesNames = {
  COL: 'Colombia',
  MEX: 'México',
  ARG: 'Argentina',
  BRA: 'Brasil',
  BOL: 'Bolivia',
  CHI: 'Chile',
  PER: 'Perú'
}

export const bankingPartnersByCountry = {
  COL: [{ name: 'COBRE' }, { name: 'FACILITA' }, { name: 'IRIS' }, { name: 'KOYWE' }, { name: 'MURAL' }, { name: 'PASSPORT' }, { name: 'PLENTI' }],
  MEX: [{ name: 'COBRE' }, { name: 'FACILITA' }, { name: 'KOYWE' }],
  ARG: [{ name: 'KOYWE' }],
  BRA: [{ name: 'FACILITA' }, { name: 'KOYWE' }],
  BOL: [{ name: 'KOYWE' }],
  CHI: [{ name: 'FACILITA' }, { name: 'KOYWE' }],
  PER: [{ name: 'KOYWE' }]
}

export const bankingPartnerLogos = {
  monnet: MonnetLogo,
  'cobre-pexto-v3': CobreLogo,
  'cobre-pexto-v3-mxn': CobreLogo,
  'koywe-clp': KoyweLogo,
  'koywe-bob': KoyweLogo,
  'koywe-ars': KoyweLogo,
  'koywe-pen': KoyweLogo,
  'facilita-brl': FacilitaLogo,
  'passport-col': PassportLogo,
  'plenti-col': PlentiLogo
}
